module.exports = __webpack_public_path__ + "img/mh.40dbb5c2.svg";